<div class="p-2 menu-navigation">
  <mat-nav-list>
    @if (canAccessHomePage()) {
      <a
        mat-list-item
        [routerLink]="buildRoute(['home'])"
        [routerLinkActiveOptions]="{ exact: true }"
        routerLinkActive="menu-active"
      >
        <div class="menu-item">
          <mat-icon>home</mat-icon>
          <div class="menu-item-text">Home</div>
        </div>
      </a>
    }
    <a
      mat-list-item
      *accessView="['view_projects']"
      [routerLink]="buildRoute(['projects'])"
      routerLinkActive="menu-active"
    >
      <div class="menu-item">
        <mat-icon>projects</mat-icon>
        <div class="menu-item-text">Projects</div>
      </div>
    </a>
    <a
      mat-list-item
      *accessView="['view_datasource']"
      [routerLink]="buildRoute(['data-sources'])"
      routerLinkActive="menu-active"
    >
      <div class="menu-item">
        <mat-icon>database</mat-icon>
        <div class="menu-item-text">Discover</div>
      </div>
    </a>
    <a
      mat-list-item
      *accessView="['view_connector']"
      [routerLink]="buildRoute(['connectors'])"
      routerLinkActive="menu-active"
    >
      <div class="menu-item">
        <mat-icon>schema</mat-icon>
        <div class="menu-item-text">Ingest</div>
      </div>
    </a>
    <a
      mat-list-item
      *accessView="['view_pipeline']"
      [routerLink]="buildRoute(['pipelines'])"
      routerLinkActive="menu-active"
    >
      <div class="menu-item">
        <mat-icon>valve</mat-icon>
        <div class="menu-item-text">Publish</div>
      </div>
    </a>

    <a mat-list-item *accessView="['view_vpnconfig', 'view_department']" (click)="toggleConfigurationSubMenu()">
      <div class="menu-item">
        <mat-icon>settings</mat-icon>
        <div class="menu-item-text">Configuration</div>
        @if (configurationSubMenuOpen()) {
          <mat-icon class="ms-5">arrow_drop_up</mat-icon>
        } @else {
          <mat-icon class="ms-5">arrow_drop_down</mat-icon>
        }
      </div>
    </a>

    @if (configurationSubMenuOpen()) {
      <div class="ms-3">
        <a
          mat-list-item
          *accessView="['view_vpnconfig']"
          [routerLink]="buildRoute(['vpn-configuration'])"
          routerLinkActive="menu-active"
        >
          <div class="menu-item">
            <mat-icon>vpn_lock_2</mat-icon>
            <div class="menu-item-text">VPN</div>
          </div>
        </a>

        <a
          mat-list-item
          *accessView="['view_department']"
          [routerLink]="buildRoute(['departments'])"
          routerLinkActive="menu-active"
        >
          <div class="menu-item">
            <mat-icon>groups</mat-icon>
            <div class="menu-item-text">Departments</div>
          </div>
        </a>
      </div>
    }

    <a
      mat-list-item
      *accessView="['view_user']"
      [routerLink]="buildRoute(['user-management'])"
      routerLinkActive="menu-active"
    >
      <div class="menu-item">
        <mat-icon>manage_accounts</mat-icon>
        <div class="menu-item-text">User Management</div>
      </div>
    </a>

    <a
      mat-list-item
      *accessView="['view_auditlog']"
      [routerLink]="buildRoute(['audit-log'])"
      routerLinkActive="menu-active"
    >
      <div class="menu-item">
        <mat-icon>summarize</mat-icon>
        <div class="menu-item-text">Audit Log</div>
      </div>
    </a>
    <mat-list-item class="d-none">
      <div class="menu-item">
        <mat-icon>orders</mat-icon>
        <div class="menu-item-text">Order management</div>
      </div>
    </mat-list-item>
    <mat-list-item class="d-none">
      <div class="menu-item">
        <mat-icon>notifications_none</mat-icon>
        <div class="menu-item-text">Notifications</div>
      </div>
    </mat-list-item>
  </mat-nav-list>
</div>
